import { GridLines } from "./components/shared";
import { Navbar, Footer, DividerDashed } from "./components/layout";
import {
  Hero,
  Problem,
  FeaturesGrid,
  CtaResult,
  PillarGestiona,
  PillarAutomatiza,
  PillarControla,
  InvestorPortal,
  CtaFinal,
} from "./components/sections";
import { useGridIntensityInit } from "./hooks";
import { useScrollDepth } from "../hooks/useScrollDepth";

export function LandingPage() {
  // Initialize grid lines with subtle intensity (Hero/SocialProof area)
  useGridIntensityInit("subtle");

  // Track scroll depth for analytics
  useScrollDepth();

  return (
    <div className="min-h-screen bg-primary relative">
      {/* Skip to content link - visible on focus for keyboard users */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-text-primary focus:rounded-md focus:outline-none focus:ring-2 focus:ring-accent"
      >
        Saltar al contenido
      </a>

      {/* Grid Lines Overlay - Always visible (Linear-style) */}
      <GridLines />

      {/* Navbar */}
      <Navbar />

      <main id="main-content">
        {/* Hero Section */}
        <Hero />

        {/* Problem Section */}
        <Problem />

        {/* Features Grid */}
        <FeaturesGrid />

        {/* Pillar 1: Gestiona */}
        <PillarGestiona />

        {/* Pillar 2: Automatiza */}
        <PillarAutomatiza />

        {/* Pillar 3: Controla */}
        <PillarControla />

        <DividerDashed intensity="medium" />

        {/* CTA Result */}
        <CtaResult />

        <DividerDashed intensity="medium" />

        {/* Investor Portal Section */}
        <InvestorPortal />

        <DividerDashed intensity="hard" />

        {/* Final CTA Section */}
        <CtaFinal />

        {/* Footer */}
        <Footer />
      </main>
    </div>
  );
}
